'use strict';

import queryString from 'query-string';
import {eventEmitter} from "../../common/index";

class Filter {
	constructor(params) {
		this.ajaxURL = params.ajaxUrl;
		// HTML elements
		this.params = params;
		this.form = document.querySelector(`form[data-block="${params.formBlock}"]`);
		this.additional = document.querySelector(`[data-block="${params.additionalBlock}"]`);

		this.timer = null;
		this.sendingRequest = 0;
		this.messages = params.messages;
		this.sessid = params.sessid;
		this.lang = params.lang;
		this.cacheKey = '';
		this.cache = [];
	}

	get rangeMinPrice() {
		return this._rangeMinPrice;
	}

	set rangeMinPrice(value) {
		this._rangeMinPrice = value;
	}

	get rangeMaxPrice() {
		return this._rangeMaxPrice;
	}

	set rangeMaxPrice(value) {
		this._rangeMaxPrice = value;
	}

	get rangeMinPriceElement() {
		return this._rangeMinPriceElement;
	}

	set rangeMinPriceElement(element) {
		this._rangeMinPriceElement = element;
	}

	get rangeMaxPriceElement() {
		return this._rangeMaxPriceElement;
	}

	set rangeMaxPriceElement(element) {
		this._rangeMaxPriceElement = element;
	}

	get resultPopup() {
		if (!this._resultPopup) {
			let wrapper = document.createElement('span');
			wrapper.className = 'popup-result';
			this.resultPopup = wrapper;
		}
		return this._resultPopup;
	}

	set resultPopup(popup) {
		this._resultPopup = popup;
	}

	set sessid(sessid) {
		this._sessid = sessid;
	}

	get sessid() {
		return this._sessid;
	}

	set position(position) {
		this._position = position;
	}

	get position() {
		return this._position;
	}

	set messages(messages) {
		this._messages = messages;
	}

	get messages() {
		return this._messages;
	}

	set lang(lang) {
		this._lang = lang;
	}

	get lang() {
		return this._lang;
	}

	set cache(cache) {
		this._cache = cache;
	}

	get cache() {
		return this._cache;
	}

	set form(form) {
		this._form = form;
	}

	get form() {
		return this._form;
	}

	set additional(block) {
		this._additional = block;
	}

	get additional() {
		return this._additional;
	}

	get baseRequestValues() {
		return {ajax: 'y', lang: this.lang, sessid: this.sessid};
	}

	makeCacheKeyByValues(values) {
		let cacheKey = '';
		for (let i = 0; i < values.length; i++)
			cacheKey += values[i].name + ':' + values[i].value + '|';
		this.cacheKey = cacheKey;
		return this;
	}

	get cachedData() {
		return this.cache[this.cacheKey];
	}

	get cacheKey() {
		return this._cacheKey;
	}

	set cacheKey(cacheKey) {
		this._cacheKey = cacheKey;
	}

	close() {
		document.querySelector('.filter-section').classList.remove('opened');
		let bg = document.querySelector('.bg');
		bg.classList.remove('active');
		bg.style.zIndex = 1066;
		document.querySelector('body').classList.remove('filter-open');
		return this;
	}

	open() {
		document.querySelector('.filter-section').classList.add('opened');
		let bg = document.querySelector('.bg');
		bg.classList.add('active');
		bg.style.zIndex = 1066;
		document.querySelector('body').classList.add('filter-open');
		return this;
	}

	showAdditionalValues(item) {
		let parent = item.parentElement;
		// Show values
		if (parent instanceof HTMLElement && parent.classList.contains('filter-box__container')) {
			let hiddenItems = parent.querySelectorAll('.filter-item[data-block="additional"]');
			if (hiddenItems.length) {
				hiddenItems.forEach(function (value) {
					value.classList.remove('hidden');
				});
			}
			// Hide show values button
			item.classList.add("hidden");
			// Show hide value button
			item.nextElementSibling.classList.remove("hidden");
		}
		return this;
	}

	hideAdditionalValues(item) {
		let parent = item.parentElement;
		// Hide values
		if (parent instanceof HTMLElement && parent.classList.contains('filter-box__container')) {
			let hiddenItems = parent.querySelectorAll('.filter-item[data-block="additional"]');
			if (hiddenItems.length) {
				hiddenItems.forEach(function (value) {
					value.classList.add('hidden');
				});
			}
			// Hide hide values button
			item.classList.add("hidden");
			// Show show value button
			item.previousElementSibling.classList.remove("hidden");
		}
		return this;
	}

	get inputElements() {
		return this.form.querySelectorAll('input, select');
	}

	request(data) {
		let headers = new Headers();
		headers.append('Content-type', 'application/json;');
		let options = {
			method: 'GET',
			mode: 'same-origin',
			cache: 'no-cache',
			headers: headers
		};

		let url = this.ajaxURL;

		if (/.*\?q=.*/.test(url))
			url += '&';
		else
			url += '?';

		url += data;

		return fetch(url, options);
	}

    elementPosition(elem) {
        let node = elem.closest('.input-checkbox');
        if(!(node instanceof HTMLElement))
            node = elem.closest('.bx-filter-input-container');

        if(!(node instanceof HTMLElement)) return {};

        let box = node.getBoundingClientRect();

        return {top: node.offsetTop - 10, left: box.left + pageXOffset};
    }

	/**
	 * Update property values after request
	 * @param PID
	 * @param arItem
	 */
	updateItem(PID, arItem) {
		if (arItem.PRICE) {

            let priceBox = this.form.querySelector('.filter-box.price-box');
            if(!(priceBox instanceof HTMLElement)) return;

            let minPrice = parseInt(arItem.VALUES.MIN.hasOwnProperty('FILTERED_VALUE')
				? arItem.VALUES.MIN['FILTERED_VALUE'] : arItem.VALUES.MIN['VALUE'], 10);

            let maxPrice = parseInt(arItem.VALUES.MAX.hasOwnProperty('FILTERED_VALUE')
                ? arItem.VALUES.MAX['FILTERED_VALUE'] : arItem.VALUES.MAX['VALUE'], 10);

            let values = [Number(this.rangeMinPriceElement.value), Number(this.rangeMaxPriceElement.value)];

            if(Number(values[0]) < minPrice || Number(values[0]) > maxPrice) {
                this.rangeMinPriceElement.value = this.rangeMinPrice = minPrice;
				if (this.priceSliders) this.priceSliders.min.value = minPrice;
			}


            if(Number(values[1]) > maxPrice || Number(values[1]) < minPrice) {
                this.rangeMaxPriceElement.value = this.rangeMaxPrice = maxPrice;
				if (this.priceSliders) this.priceSliders.max.value = maxPrice;
			}

			if (this.priceSliders) {
				this.priceSliders.min.min = this.priceSliders.max.min = minPrice;
				this.priceSliders.min.max = this.priceSliders.max.max = maxPrice;
			}

		} else if (arItem.VALUES) {
			for (let i in arItem.VALUES) {
				if (arItem.VALUES.hasOwnProperty(i)) {
					let value = arItem.VALUES[i];
					let control = this.form.querySelector(`#${value.CONTROL_ID}`);

					if (!!control) {
						let item = control.closest('.filter-item ');
						let label = this.form.querySelector('[data-role="label_' + value.CONTROL_ID + '"]');
						if (value.DISABLED) {
							if (label)
								label.classList.add('disabled');
							else
								control.parentElement.classList.add('disabled');
							control.classList.add('disabled');
							control.disabled = true;

							if ((item.classList.contains('disabled') && item.hasAttribute('style')) || !item.classList.contains('disabled'))
								item.style.display = 'none';
						} else {
							if (label)
								label.classList.remove('disabled');
							else
								control.parentElement.classList.remove('disabled');

							control.classList.remove('disabled');
							control.disabled = false;

							if (item.style.display !== 'block')
								item.style.display = 'block';
						}

						if (value.hasOwnProperty('ELEMENT_COUNT')) {
							label = document.querySelector('[data-role="count_' + value.CONTROL_ID + '"]');
							if (label)
								label.innerHTML = `(${value.ELEMENT_COUNT})`;
						}
					}
				}
			}
		}
	}

	// Возвращает дочерние категории выбранного раздела
	getCategoryChildren(element) {
		let currentItem = element.closest('[data-category-item]');
		if (!(currentItem instanceof HTMLElement)) return [];
		return Array.from(this.form.querySelectorAll('[data-category-item]'))
			.filter(item => item.dataset.parentId === currentItem.dataset.sectionId);
	}

	// Отмечает категории с подразделами для отображения стрелки раскрытия
	markCategoryParents() {
		if (!this.form) return this;
		let categoryItems = Array.from(this.form.querySelectorAll('[data-category-item]'));
		let parentIds = new Set(categoryItems.map(item => item.dataset.parentId).filter(Boolean));
		categoryItems.forEach(item => {
			item.classList.toggle('category-has-children', parentIds.has(item.dataset.sectionId));
		});
		return this;
	}

	// Сворачивает всю ветку дочерних категорий выбранного раздела
	hideCategoryBranch(element) {
		let parentIds = [element.closest('[data-category-item]').dataset.sectionId];
		let items = this.form.querySelectorAll('[data-category-item]');
		for (let i = 0; i < parentIds.length; i++) {
			items.forEach(item => {
				if (item.dataset.parentId !== parentIds[i]) return;
				item.classList.add('hidden');
				item.classList.remove('category-expanded');
				parentIds.push(item.dataset.sectionId);
			});
		}
	}

	// Показывает доступные подразделы сразу под выбранной категорией
	showCategoryChildren(element, resolvedChildren = null) {
		let currentItem = element.closest('[data-category-item]');
		let insertAfter = currentItem;
		let children = resolvedChildren || this.getCategoryChildren(element);
		children.forEach(item => {
			insertAfter.after(item);
			insertAfter = item;
			let input = item.querySelector('input[type="checkbox"]');
			if (input && !input.disabled) item.classList.remove('hidden');
		});
		currentItem.classList.add('category-expanded');
	}

	// Раскрывает путь к выбранным категориям после загрузки страницы
	showSelectedCategoryPaths() {
		let categoryItems = Array.from(this.form.querySelectorAll('[data-category-item]'));
		let itemsBySectionId = categoryItems.reduce((items, item) => {
			items[item.dataset.sectionId] = item;
			return items;
		}, {});

		categoryItems.forEach(selectedItem => {
			let selectedInput = selectedItem.querySelector('[data-property-code="CATEGORY"]:checked');
			if (!selectedInput) return;

			let path = [];
			let parentId = selectedItem.dataset.parentId;
			while (parentId && itemsBySectionId[parentId]) {
				let parentItem = itemsBySectionId[parentId];
				path.unshift(parentItem);
				parentId = parentItem.dataset.parentId;
			}

			path.forEach(parentItem => {
				let parentInput = parentItem.querySelector('[data-property-code="CATEGORY"]');
				if (parentInput) this.showCategoryChildren(parentInput);
			});
			selectedItem.classList.remove('hidden');
		});

		return this;
	}

	// Обновляет доступность и количество товаров у подразделов из AJAX-ответа
	updateCategoryChildren(element, response) {
		let categoryItem = Object.values(response.ITEMS || {})
			.find(item => item.CODE === 'CATEGORY');
		if (!categoryItem || !categoryItem.VALUES) return [];

		let responseValues = Object.values(categoryItem.VALUES);
		let children = this.getCategoryChildren(element);

		children.forEach(item => {
			let input = item.querySelector('input[type="checkbox"]');
			if (!input) return;
			let value = responseValues.find(responseValue => responseValue.CONTROL_ID === input.id);
			let label = item.querySelector('[data-role="label_' + input.id + '"]');
			let count = item.querySelector('[data-role="count_' + input.id + '"]');

			input.disabled = !value || !!value.DISABLED || Number(value.ELEMENT_COUNT) === 0;
			item.classList.toggle('disabled', input.disabled);
			if (label) label.classList.toggle('disabled', input.disabled);
			if (count && value && value.hasOwnProperty('ELEMENT_COUNT')) {
				count.textContent = `(${value.ELEMENT_COUNT})`;
			}
		});
		return children.filter(item => {
			let input = item.querySelector('input[type="checkbox"]');
			return input && !input.disabled;
		});
	}

	// По клику на текст загружает подразделы, а для конечной категории включает checkbox
	onCategoryTextClick(element) {
		let self = this;
		if (!this.form) return;
		let currentItem = element.closest('[data-category-item]');
		if (!(currentItem instanceof HTMLElement)) return;

		if (currentItem.classList.contains('category-expanded')) {
			this.hideCategoryBranch(element);
			currentItem.classList.remove('category-expanded');
			return;
		}

		eventEmitter.emit('showLoader');
		this.curFilterinput = element;
		this.sendingRequest++;
		let values = this.gatherInputsValues(this.baseRequestValues, this.inputElements);
		if (!values.hasOwnProperty(element.name)) values[element.name] = [];
		if (values[element.name].indexOf(element.value) === -1) values[element.name].push(element.value);
		values = this.checkPriceValues(values);
		if (values.hasOwnProperty('q')) delete values.q;

		this.request(this.prepareData(values))
			.then(res => res.json())
			.then(response => {
				self.sendingRequest--;
				let children = response && response.ITEMS
					? self.updateCategoryChildren(element, response)
					: [];
				eventEmitter.emit('hideLoader');
				if (children.length === 0) {
					element.click();
					return;
				}
				self.showCategoryChildren(element, children);
			})
			.catch(error => {
				self.sendingRequest--;
				eventEmitter.emit('hideLoader');
				console.error('Error:', error);
			});
	}

	pluralForm(q, mess1, mess2, mess5) {
		let n = Math.abs(q) % 100;
		let n1 = n % 10;

		if (n > 10 && n < 20) return mess5;
		if (n1 > 1 && n1 < 5) return mess2;
		if (n1 == 1) return mess1;
		return mess5;
	}

	activateMobileButton(params) {
		let button = this.form.querySelector('#set_filter');
		let message = this.pluralForm(params.count, 'CT_BCSF_FILTER_PRODUCTS_1', 'CT_BCSF_FILTER_PRODUCTS_2', 'CT_BCSF_FILTER_PRODUCTS_5');
		button.disable = false;
		button.classList.remove('disabled');
		button.innerHTML = `<span data-url="${params.url}" class="popup-result__title">${this.messages['CT_BCSF_FILTER_SHOW']} ${params.count} ${this.messages[message]}</span>`;
		return this;
	}


	showPopupResult(params) {
		this.position = this.elementPosition(this.curFilterinput, false);
		this.hidePopupResult();
		this.resultPopup.innerHTML = `<span data-url="${params.url}" class="popup-result__title">${this.messages['CT_BCSF_FILTER_SHOW']}</span>
								<span class="popup-result__num">(${params.count})</span>`;

		// Fix popup position
		this.resultPopup.style.top = this.position.top + 'px';
		this.resultPopup.classList.remove('loading-state');
		this.form.appendChild(this.resultPopup);
		return this;
	}

	popupAwaitingResult() {
		this.position = this.elementPosition(this.curFilterinput, false);
		this.hidePopupResult();
		this.resultPopup.innerHTML = `<span class="circle"></span><span class="roller"></span>`;

		// Fix popup position
		this.resultPopup.style.top = this.position.top + 'px';
		this.resultPopup.classList.add('loading-state');
		this.form.appendChild(this.resultPopup);
		return this;
	}


	hidePopupResult() {
		if (this.form.contains(this.resultPopup))
			this.form.removeChild(this.resultPopup);
		return this;
	}

	//hide property filter if all checkboxes have 0 results
	checkFilterBoxes() {
		let kid = document.querySelectorAll('.filter-box .filter-items-list');
		let empties = [];
		kid.forEach(value => {
			let box = value.closest('.filter-box');
			empties = value.querySelectorAll('input[class="disabled"]');
			if (empties.length === value.children.length) {
				box.style.display = 'none';
			} else box.style.display = 'block';
		})
	}

	onValuesChangedDesktop(e) {
		let self = this, element = e.detail.element;

		if (this.params.changeUrl === false) {
			this.onValuesChanged(e); // используем мобильную логику
			return;
		}

		if (this.form) {
			eventEmitter.emit('showLoader');
			this.curFilterinput = element;
			this.sendingRequest++;
			let elements = this.inputElements;
			let values = this.baseRequestValues;
			values = this.gatherInputsValues(values, elements);
			values = this.checkPriceValues(values);

			if (values.hasOwnProperty('q'))
				delete values['q'];

			let data = this.prepareData(values);
			// Make request
			this.deactivateMobileButton();
			this.request(data)
				.then(res => res.json())
				.then((response) => {
					self.sendingRequest--;
					self.responseHandlerDesktop(response, false);
					this.checkFilterBoxes();
					eventEmitter.emit('hideLoader');
				})
				.catch(error => {
					self.sendingRequest--;
					console.error('Error:', error)
				});
		}
	}

	onValuesChanged(e) {
		let self = this, element = e.detail.element;
		this.cacheKey = '|';
		if (this.form) {
			eventEmitter.emit('showLoader');
			this.curFilterinput = element;
			this.popupAwaitingResult();
			this.sendingRequest++;
			let elements = this.inputElements;
			let values = this.baseRequestValues;
			values = this.gatherInputsValues(values, elements);
			values = this.checkPriceValues(values);

			this.makeCacheKeyByValues(values);

			if (values.hasOwnProperty('q'))
				delete values['q'];

			// Check cache
			let cachedData = this.cachedData;
			if (cachedData) {
				self.sendingRequest--;
				this.responseHandler(cachedData, true);
				this.checkFilterBoxes();
				eventEmitter.emit('hideLoader');
			} else {
				let data = this.prepareData(values);
				// Make request
				this.deactivateMobileButton();
				this.request(data)
					.then(res => res.json())
					.then((response) => {
						self.sendingRequest--;
						self.responseHandler(response, false);
						this.checkFilterBoxes();
						eventEmitter.emit('hideLoader');
					})
					.catch(error => {
						self.sendingRequest--;
						console.error('Error:', error)
					});
			}
		}
	}

	/**
	 * Check price input change values
	 * @param values
	 * @returns {*} Object
	 */
	checkPriceValues(values) {
		if (!(this.rangeMinPriceElement instanceof HTMLElement) || !(this.rangeMaxPriceElement instanceof HTMLElement)) return values;
		let minPrice = (values.hasOwnProperty(this.rangeMinPriceElement.name)) ? parseInt(values[this.rangeMinPriceElement.name], 10) : 0,
			maxPrice = (values.hasOwnProperty(this.rangeMaxPriceElement.name)) ? parseInt(values[this.rangeMaxPriceElement.name], 10) : 0;
		if (maxPrice > 0 && this.rangeMaxPrice === maxPrice && minPrice === this.rangeMinPrice) {
			delete values[this.rangeMinPriceElement.name];
			delete values[this.rangeMaxPriceElement.name];
		}
		return values;
	}

	/**
	 * Deactivate filter button on mobile devices
	 * @returns {Filter}
	 */
	deactivateMobileButton() {
		let button = this.form.querySelector('#set_filter');
		button.disabled = true;
		button.classList.add('disabled');
		button.innerHTML = '';
		return this;
	}

	responseHandlerDesktop(result, fromCache) {
		if (!!result && !!result.ITEMS) {
			let link = result.FILTER_URL
			if (typeof link === 'string' && link.length > 0)
				window.location.href = link
		}
		if (!fromCache && this.cacheKey !== '') this.cache[this.cacheKey] = result;
		this.cacheKey = '';
	}

	responseHandler(result, fromCache) {
		if (!!result && !!result.ITEMS) {
			for (let PID in result.ITEMS)
				if (result.ITEMS.hasOwnProperty(PID))
					this.updateItem(PID, result.ITEMS[PID]);

			let params = {
				url: result.FILTER_URL,
				count: result.ELEMENT_COUNT
			};
			// Desktop, mobile button
			if (this.sendingRequest === 0) {
				this.hidePopupResult();
				this.activateMobileButton(params)
				setTimeout(() => {this.showPopupResult(params)}, 200);
			}

		}
		if (!fromCache && this.cacheKey !== '') this.cache[this.cacheKey] = result;
		this.cacheKey = '';
	}

	gatherInputsValues(values, elements) {
		if (elements) {
			for (let i = 0; i < elements.length; i++) {
				let el = elements[i];
				if (el.disabled || !el.type)
					continue;

				switch (el.type.toLowerCase()) {
					case 'text':
					case 'textarea':
					case 'password':
					case 'hidden':
					case 'select-one':
						if (el.value.length)
							values[el.name] = el.value;
						break;
					case 'radio':
					case 'checkbox':
						if (el.checked) {
							if (!values.hasOwnProperty(el.name)) values[el.name] = [];
							values[el.name].push(el.value);
						}
						break;
					case 'select-multiple':
						if (!values.hasOwnProperty(el.name)) values[el.name] = [];
						for (let j = 0; j < el.options.length; j++) {
							if (el.options[j].selected)
								values[el.name].push(el.options[j].value);
						}
						break;
					default:
						break;
				}
			}
		}
		return values;
	}

	prepareData(values) {
		return queryString.stringify(values);
	}

	hideAllValues(element) {
		let parent = element.parentElement, nextSibling = element.nextElementSibling;
		if (parent.classList.contains('active')) {
			parent.classList.remove('active');
			nextSibling.classList.add('collapsed');
		} else {
			parent.classList.add('active');
			nextSibling.classList.remove('collapsed');
		}
	}
}

export {Filter};